import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SkeletonLoader from '../../components/SkeletonLoader';
import { listHistory } from '../../Api';

// Function to parse Indonesian date format (dd-MMM-yyyy) into JavaScript Date
const parseDateWithIndonesianMonth = (dateString) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    Mei: "05",
    Jun: "06",
    Jul: "07",
    Agu: "08",
    Sep: "09",
    Okt: "10",
    Nov: "11",
    Des: "12",
  };

  const [day, month, year] = dateString.split("-");
  const normalizedMonth = months[month];
  if (!normalizedMonth) return null;

  return new Date(`${year}-${normalizedMonth}-${day}`);
};

function History({ dateRange }) {
  const [history, setHistory] = useState(null);
  const [filteredHistory, setFilteredHistory] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchOnceRef = useRef(false);
  const navigate = useNavigate();

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const data = await listHistory();
      setHistory(data);
    } catch (err) {
      setError('Failed to fetch history data');
    } finally {
      setLoading(false);
    }
  };

  const filterHistory = () => {
    if (!history) return;

    if (!dateRange) {
      setFilteredHistory(history);
      return;
    }

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - dateRange);

    const filtered = {};
    Object.keys(history).forEach((monthYear) => {
      const filteredItems = history[monthYear].filter((item) => {
        const itemDate = parseDateWithIndonesianMonth(item.tgl_service);
        return (
          itemDate &&
          itemDate >= pastDate &&
          itemDate <= today
        );
      });

      if (filteredItems.length > 0) {
        filtered[monthYear] = filteredItems;
      }
    });

    setFilteredHistory(filtered);
  };

  useEffect(() => {
    if (fetchOnceRef.current) return;
    fetchOnceRef.current = true;
    fetchHistory();
  }, []);

  useEffect(() => {
    filterHistory();
  }, [history, dateRange]);

  const handleItemClick = (item) => {
    navigate(`/detailhistory/${item.id}`, { state: { item } });
  };

  return (
    <div className="historypage">
      {loading ? (
        <div>
          <SkeletonLoader count={3} height={50} />
          <SkeletonLoader count={5} height={30} />
        </div>
      ) : error ? (
        <p>{error}</p>
      ) : filteredHistory && Object.keys(filteredHistory).length === 0 ? (
        <p className="infotext">Anda Belum memiliki Riwayat Servis</p>
      ) : (
        filteredHistory &&
        Object.keys(filteredHistory).map((monthYear) => (
          <div key={monthYear} className="history-group">
            <h3 className="month-header">{monthYear}</h3>
            <div className="item-list"  style={{cursor:'pointer'}}>
              {filteredHistory[monthYear].map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="item"
                  onClick={() => handleItemClick(item)}
                >
                  <div className="item-date">
                    <span className="item-day">
                      {item.tgl_service.split('-')[0]}
                    </span>
                    <span className="item-month">
                      {item.tgl_service.split('-')[1]}
                    </span>
                    <span className="item-year">
                      {item.tgl_service.split('-')[2]}
                    </span>
                  </div>
                  <div className="item-content">
                    <h3 className="item-title">{item.ac.nama_ac}</h3>
                    <p className="item-description">{item.tipe_pengerjaan}</p>
                  </div>
                  <div className="item-status">
                    <span
                      className={
                        item.status === 'Completed'
                          ? 'status-green'
                          : item.status === 'Requested'
                          ? 'status-grey'
                          : 'status-red'
                      }
                    >
                      {item.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default History;
